export default __webpack_public_path__ + "static/media/logo.d2c38c99.webp";